import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import FlagIcon from "vue-flag-icon";
import axios from "axios";
import store from "./store";
import i18n from "@/plugins/i18n";
import VueCookies from "vue-cookies";

Vue.prototype.$http = axios;
axios.defaults.headers.common["Content-Type"] = "application/json";

const token = localStorage.getItem("Token");
const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
if (token && isLoggedIn) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}

let tokenHandled = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const msg = error?.response?.data?.message || error.message || "";

    const isExpired =
      status === 401 ||
      msg.includes("Token หมดอายุ") ||
      msg.includes("Your session has expired");

    const hasSession = Boolean(localStorage.getItem("Token"));

    if (isExpired && hasSession && !tokenHandled) {
      tokenHandled = true;
      store
        .dispatch(
          "ForceLogout",
          msg || "Token ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่"
        )
        .finally(() => {
          tokenHandled = false;
        });
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

function startTokenWatcher() {
  setInterval(() => {
    const token = localStorage.getItem("Token");
    if (!token) return;

    try {
      const encodedPayload = token
        .split(".")[1]
        .replace(/-/g, "+")
        .replace(/_/g, "/");
      const payload = JSON.parse(atob(encodedPayload));
      const exp = payload.exp * 1000;
      const now = Date.now();

      if (exp <= now) {
        console.warn(
          "⏰ Token expired (client-detected), triggering logout immediately"
        );
        store.dispatch(
          "ForceLogout",
          "Token ของคุณหมดอายุ กรุณาเข้าสู่ระบบใหม่"
        );
      }
    } catch (e) {
      console.error("Token decode error:", e);
    }
  }, 10000);
}

startTokenWatcher();

window.$ = window.jQuery = require("jquery");
Vue.config.productionTip = false;
Vue.use(FlagIcon);
Vue.use(VueCookies);
new Vue({
  i18n,
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
